import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model';
import {GET_STREAMS_SUCCESS, GetStreamsSuccessAction, StreamsActions} from '../actions/streams.actions';
export interface StreamsState {
  streams: PaymentStreamSetting[];
}

export const initialState: StreamsState = {
  streams: []
};

export function streamsReducer (state = initialState, action: StreamsActions) {
  switch (action.type) {
    case GET_STREAMS_SUCCESS:
      return {
        streams: [...(action as GetStreamsSuccessAction).payload]
      };
    default:
      return {
        ...state
      };
  }
}
